// extracted by mini-css-extract-plugin
export default {"root":"PviRfNCUGhq0_ij57NKK","details-page__input":"YbQeb1UP7473YsyEVbYG"};